<template>
  <div class="landingPage" :class="{ 'is-overlapped': isHeaderOverlapped }">
    <div class="landingPage-img">
      <img src="@/assets/style/landingPage-icon.png" alt="" />
    </div>
    <!--头部-->
    <Navbar :isNotify="false" :isCustomerService="false" :showLeft="false">
      <template #left>
        <div class="left-content">
          <img
            class="guide-logo-icon"
            src="@/assets/style/guide-logo-icon.png"
            alt=""
          />
          <div class="text">
            <span class="span">新享管家</span>
            <span class="tip">财富好管家</span>
          </div>
        </div>
      </template>
      <template #right>
        <div class="right-content">
          <img src="@/assets/style/landingPage-img.png" alt="" />
        </div>
      </template>
    </Navbar>
    <div ref="contentSentinel" class="content-sentinel"></div>
    <!--卡片-->
    <pageCard ref="pageCardRef" />
    <!--输入手机号-->
    <div class="phoneField">
      <phoneField v-model="phone" ref="phoneFieldRef" />
    </div>
    <!--登录协议-->
    <div class="protocolField">
      <protocolField
        v-model="isChecked"
        labelColor="#FFFFFF"
        protocolColor="#FFD900"
        protocolType="3"
        routerName="landingPage"
        isLogin
      />
    </div>
    <!--绑定渠道-->
    <div class="bindChannel">
      <van-button class="btn" type="primary" block @click="handleBind"
        >立即领取额度</van-button
      >
    </div>
    <!--保障申明-->
    <div class="warrantyStatement">
      <warrantyStatement />
    </div>
    <div class="riskTip">
      贷款有风险，借贷需谨慎，请根据个人能力合理贷款
      贷款额度、利率、放款时间以实际审核为准
    </div>
    <Popup
      ref="popup"
      message="请先阅读并同意相关协议"
      confirmText="我已阅读并同意"
      cancelText="不同意"
      @confirm="handleConfirm"
    />
  </div>
</template>

<script>
import { bindChannel, setViewCount } from "@/api/index.js";
import Navbar from "@/components/navbar/index.vue";
import pageCard from "@/components/landingPage/pageCard.vue";
import phoneField from "@/components/login/phoneField.vue";
import protocolField from "@/components/protocolField/index.vue";
import warrantyStatement from "@/components/landingPage/warrantyStatement.vue";
import Popup from "@/components/Popup/index.vue";
import checkEnvironment from "@/hooks/checkEnvironment.js";

export default {
  name: "LandingPage",
  components: {
    Navbar,
    pageCard,
    phoneField,
    protocolField,
    warrantyStatement,
    Popup
  },
  data() {
    return {
      isChecked: false,
      phone: "",
      isHeaderOverlapped: false,
      code: "",
    };
  },
  async mounted() {
    checkEnvironment();
    this.handlePageCardHeight();
    this.$nextTick(() => {
      this.initHeaderOverlapObserver();
    });
  },
  methods: {
    handleConfirm() {
      this.isChecked = true;
    },
    initHeaderOverlapObserver() {
      const sentinelEl = this.$refs.contentSentinel;
      if (!sentinelEl || typeof IntersectionObserver === "undefined") return;

      const rootEl = this.$el;
      this._contentObserver?.disconnect();
      this._contentObserver = new IntersectionObserver(
        ([entry]) => {
          this.isHeaderOverlapped = entry ? !entry.isIntersecting : false;
        },
        {
          root: rootEl,
          threshold: 0,
          rootMargin: `-${46}px 0px 0px 0px`,
        },
      );
      this._contentObserver.observe(sentinelEl);
    },
    //计算卡片的高度并且设置输入手机号的位置在卡片的下方
    handlePageCardHeight() {
      const pageCardHeight = this.$refs.pageCardRef.$el.clientHeight;
      this.$refs.phoneFieldRef.$el.style.margin = `${
        pageCardHeight + 36
      }px 0px 0px 0px`;
    },
    //渠道绑定
    async handleBind() {
      if (!this.phone) {
        this.$toast("请输入手机号");
        return;
      }
      if (!this.isChecked) {
        this.$refs.popup.showPopup();
        return;
      }
      const res = await bindChannel(this.$store.state.channelId, {
        phoneNumber: this.phone,
        code: this.code,
      });
      if (res.code === 2000) {
        //浏览量结算
        await setViewCount({
          channelId: this.$store.state.channelId,
        });
        this.$router.push({
          path: "/landingPageResule",
        });
      } else {
        this.$toast(res.msg || res.message || "绑定失败");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.landingPage {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background: linear-gradient(180deg, #e4eeff 0%, #1d70f7 100%);
}
.content {
  position: absolute;
  z-index: 2;
  width: 100%;
  .content-wrap {
    margin: 16px;
  }
}
.landingPage-img {
  position: absolute;
  top: 0;
  right: 0;
  img {
    width: 198px;
    height: 131px;
  }
}
 ::v-deep(.van-nav-bar) {
    padding-top: 6px;
    padding-bottom: 2px;
  }
.landingPage.is-overlapped {
  ::v-deep(.van-nav-bar) {
    background: #dce9ff !important;
  }
  ::v-deep(.van-nav-bar__title) {
    color: #fff;
  }
}
::v-deep(.van-nav-bar) {
  background: transparent !important;
}
.left-content {
  display: flex;
  align-items: center;
  color: #1d70f7;
  .text {
    margin-left: 6px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .span {
      font-size: 20px;
      font-weight: 600;
    }
  }
  img {
    width: 50px;
    height: 50px;
  }
}
.right-content {
  img {
    height: 24px;
  }
}
.phoneField,.codeField {
  margin-top: 16px;
  padding: 0px 20px;
}
.bindChannel {
  margin-top: 16px;
  padding: 0px 20px;
  .btn {
    background: #1d70f7;
    border-radius: 30px;
    border: none;
    color: #fff;
  }
}
.protocolField {
  margin-top: 16px;
  padding: 0px 20px;
}
.warrantyStatement {
  margin-top: 16px;
  padding: 0px 20px;
}
.riskTip {
  margin-top: 16px;
  padding: 0px 20px;
  font-size: 12px;
  color: #fff;
  text-align: center;
  margin-bottom: 30px;
}
.content-sentinel {
  position: absolute;
  top: 46px;
  left: 0;
  width: 1px;
  height: 1px;
}
.value{
  flex: 1;
  .get-code{
    margin-right: 20px;
  }
}
</style>
